import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();

  const schema = yup.object().shape({
    start_time: yup.date().nullable().required(t('errorMessages.required')),
    end_time: yup.date().nullable().required(t('errorMessages.required')),
    delivery_destinations: yup
      .array()
      .min(1, t('sites.singleSite.dropoffLocations.timeslots.minimumLocationSelect')),
  });

  return {
    schema,
  };
};
